<template>
  <v-card>
    <template v-if="activeWidget !== undefined">
      <template v-if="activeWidget.component === 'AudioWidget'">
        <audio-widget-properties></audio-widget-properties>
      </template>
      <template v-else-if="activeWidget.component === 'ClockWidget'">
        <clock-widget-properties></clock-widget-properties>
      </template>
      <template v-else-if="activeWidget.component === 'ImageWidget'">
        <image-widget-properties></image-widget-properties>
      </template>
      <template v-else-if="activeWidget.component === 'PdfWidget'">
        <pdf-widget-properties></pdf-widget-properties>
      </template>
      <template v-else-if="activeWidget.component === 'TextWidget'">
        <text-widget-properties></text-widget-properties>
      </template>
      <template v-else-if="activeWidget.component === 'VideoWidget'">
        <video-widget-properties></video-widget-properties>
      </template>
      <template v-else-if="activeWidget.component === 'VncWidget'">
        <vnc-widget-properties></vnc-widget-properties>
      </template>
      <template v-else-if="activeWidget.component === 'TickerWidget'">
        <ticker-widget-properties></ticker-widget-properties>
      </template>
      <template v-else-if="activeWidget.component === 'WebpageWidget'">
        <webpage-widget-properties></webpage-widget-properties>
      </template>
      <template v-else-if="activeWidget.component === 'LibraryImageWidget'">
        <library-image-widget-properties></library-image-widget-properties>
      </template>
      <template v-else-if="activeWidget.component === 'LibraryAudioWidget'">
        <library-audio-widget-properties></library-audio-widget-properties>
      </template>
      <template v-else-if="activeWidget.component === 'LibraryVideoWidget'">
        <library-video-widget-properties></library-video-widget-properties>
      </template>
      <template v-else-if="activeWidget.component === 'LibraryWebpageWidget'">
        <library-webpage-widget-properties></library-webpage-widget-properties>
      </template>
      <template v-else-if="activeWidget.component === 'LibraryPdfWidget'">
        <library-pdf-widget-properties></library-pdf-widget-properties>
      </template>
      <template v-else-if="activeWidget.component === 'YoutubeWidget'">
        <youtube-widget-properties></youtube-widget-properties>
      </template>
      <template v-else-if="activeWidget.component === 'TwitterWidget'">
        <twitter-widget-properties></twitter-widget-properties>
      </template>
      <template v-else-if="activeWidget.component === 'RssWidget'">
        <rss-widget-properties></rss-widget-properties>
      </template>
      <template v-else-if="activeWidget.component === 'FacebookWidget'">
        <facebook-widget-properties></facebook-widget-properties>
      </template>
      <template v-else-if="activeWidget.component === 'MagioWidget'">
        <magio-widget-properties></magio-widget-properties>
      </template>
    </template>
    <template v-else>
      <v-toolbar color="secondary" dark tabs>
        <v-toolbar-title>{{$tc('design.property', 2)}}</v-toolbar-title>
      </v-toolbar>
    </template>
  </v-card>
</template>

<script>
import AudioWidgetProperties from './properties/AudioWidgetProperties.vue';
import ClockWidgetProperties from './properties/ClockWidgetProperties.vue';
import ImageWidgetProperties from './properties/ImageWidgetProperties.vue';
import PdfWidgetProperties from './properties/PdfWidgetProperties.vue';
import TextWidgetProperties from './properties/TextWidgetProperties.vue';
import TickerWidgetProperties from './properties/TickerWidgetProperties.vue';
import VideoWidgetProperties from './properties/VideoWidgetProperties.vue';
import VncWidgetProperties from './properties/VncWidgetProperties.vue';
import WebpageWidgetProperties from './properties/WebpageWidgetProperties.vue';
import LibraryImageWidgetProperties from './properties/LibraryImageWidgetProperties.vue';
import LibraryAudioWidgetProperties from './properties/LibraryAudioWidgetProperties.vue';
import LibraryVideoWidgetProperties from './properties/LibraryVideoWidgetProperties.vue';
import LibraryWebpageWidgetProperties from './properties/LibraryWebpageWidgetProperties.vue';
import LibraryPdfWidgetProperties from './properties/LibraryPdfWidgetProperties.vue';
import YoutubeWidgetProperties from './properties/YoutubeWidgetProperties.vue';
import TwitterWidgetProperties from './properties/TwitterWidgetProperties.vue';
import RssWidgetProperties from './properties/RssWidgetProperties.vue';
import FacebookWidgetProperties from './properties/FacebookWidgetProperties.vue';
import MagioWidgetProperties from './properties/MagioWidgetProperties.vue';

export default {
  components: {
    AudioWidgetProperties,
    ClockWidgetProperties,
    ImageWidgetProperties,
    PdfWidgetProperties,
    TextWidgetProperties,
    VideoWidgetProperties,
    VncWidgetProperties,
    TickerWidgetProperties,
    WebpageWidgetProperties,
    LibraryImageWidgetProperties,
    LibraryAudioWidgetProperties,
    LibraryVideoWidgetProperties,
    LibraryWebpageWidgetProperties,
    LibraryPdfWidgetProperties,
    YoutubeWidgetProperties,
    TwitterWidgetProperties,
    RssWidgetProperties,
    FacebookWidgetProperties,
    MagioWidgetProperties,
  },
  computed: {
    activeWidget: {
      get() {
        return this.$store.getters.getWidgetByID(this.$store.getters.getActiveWidget);
      },
    },
  },
};
</script>

<style>

</style>
